<template lang="pug">
  .layout-clean
    b-container.pt-5
      router-view
</template>

<script>

import AlertPop from '@/components/widgets/AlertPop';

export default {
  name: 'LayoutClean',
  components: {
    AlertPop,
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
  .bg{
        z-index: -1;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
      }
</style>



// WEBPACK FOOTER //
// src/components/layout/LayoutClean.vue